import React, { useEffect, useState } from "react";
import "./popular_tours.css";
import "./popular_tours.scss";
import { FaMapMarkerAlt, FaCalendarAlt, FaMapMarkedAlt } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { Link } from "react-router-dom";

const PopularTours = () => {
  const [data, setData] = useState([]);
  const [tabs, setTabs] = useState([]); // التابات من الباك إند
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    // 1- نجيب التابات (Destinations)
    fetch("https://admin.mythsegypttours.com/api/destinations")
    .then((res) => res.json())
    .then((result) => {
      setTabs(result);
      if (result.length > 0) {
        setActiveTab("all"); // أول تاب افتراضي بالـ id
      }
    });

    // 2- نجيب التورز (Home)
     fetch("https://admin.mythsegypttours.com/api/tours")
      .then((res) => res.json())
      .then((result) => {
        setData(result.data || []);
      })
      .catch((err) => console.error("Error fetching tours:", err));
  }, []);

  // فلترة حسب التاب المختار
 const filteredData =
  activeTab && activeTab !== "all"
    ? data.filter((tour) => tour.destination_id === activeTab)
    : data;


  return (
    <section className="main container section">
      <div className="secTitle">
        <span>Popular Tours & Packages</span>
        <h2 className="title">Best Egypt Tours and Travel Packages</h2>
        <p>
          Discover our best Egypt travel categories for Egypt trips
        </p>
      </div>

      {/* التابات */}
      <div className="tab-wrapper">
    <ul className="travel-tab">
  {/* تاب All */}
  <li key="all">
    <button
      className={`travel-tab-btn ${activeTab === "all" ? "active" : ""}`}
      onClick={() => setActiveTab("all")}
    >
      <FaMapLocationDot /> All
    </button>
  </li>

  {/* التابات من الباك إند */}
  {tabs.map((tab) => (
    <li key={tab.id}>
      <button
        className={`travel-tab-btn ${activeTab === tab.id ? "active" : ""}`}
        onClick={() => setActiveTab(tab.id)}
      >
        <FaMapLocationDot /> {tab.title}
      </button>
    </li>
  ))}
</ul>

      </div>

      {/* المحتوى حسب التاب */}
      <div className="secContent grid">
        {filteredData.length > 0 ? (
    filteredData.slice(0,8).map((trip)=> {
  const firstImage = trip.images?.length
    ? `https://admin.mythsegypttours.com/storage/${trip.images[0]}`
    : "https://via.placeholder.com/400x250";


            return (
              <div key={trip.id} className="singleDestination_popular">
                <div className="imgDiv">
                  <img src={firstImage} alt={trip.title} />
                </div>
                <h5 className="desTitle">{trip.title}</h5>

                <div className="cardInfo">
                  <div className="flex-container_p">
                    <span className="continent flex">
                      <FaMapMarkedAlt className="icon_p" /> {trip.places}
                    </span>
                    <span className="continent flex">
                      <FaCalendarAlt className="icon_p" /> {trip.days}
                    </span>
                   <span className="continent flex">
                    <FaMapMarkerAlt className="icon_p" /> {trip.destination?.title || "No Destination"}
                  </span>

                  </div>

                  <div className="fees flex">
                    <div className="price">
                      <h5>
                        ${trip.pricings?.length > 0 
    ? Math.min(...trip.pricings.map(p => parseFloat(p.price_per_person))) 
    : "N/A"}
                        <span>/Person</span>
                      </h5>
                    </div>

          <Link to={`/tour-details/${trip.id}`}>
  <button className="bookBtn">TOUR DETAILS</button>
</Link>

                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </section>
  );
};

export default PopularTours;
